@if (mergeRequests.length === 0) {
  <p
    class="op-tab-content--text-box"
    [innerHTML]="getEmptyText()"
  ></p>
}

@for (mergeRequest of mergeRequests; track mergeRequest) {
  <gitlab-merge-request [mergeRequest]="mergeRequest" />
}
